import { Bereavement, CarePlanFrequency, CarePlanProblems, ClearScripts, DocLink, PatientAssistance, ProgressNotes } from '@mummssoftware/utils/constants'; // component names stored in config without spaces and some with older names
// Dashboard knows what UI titles these map to from its config object, but we don't have
// access to that here. Need a switch/case.

export const getTitleFromConfig = componentName => {
  let widgetTitle;

  switch (componentName) {
    case Bereavement:
      widgetTitle = 'Care Plan - Bereavement';
      break;

    case CarePlanProblems:
      widgetTitle = 'Care Plan Problems';
      break;

    case CarePlanFrequency:
      widgetTitle = 'Care Plan - Visit Frequency';
      break;

    case DocLink:
      widgetTitle = 'Certifications';
      break;

    case PatientAssistance:
      widgetTitle = 'Completed Tasks Log';
      break;

    case ClearScripts:
      widgetTitle = 'Medications - Clearscripts';
      break;

    case ProgressNotes:
      widgetTitle = 'Orders and Progress Notes';
      break;

    default:
      widgetTitle = componentName;
      break;
  }

  return widgetTitle;
};